import React, { useEffect, useState } from 'react'
import "./navbar1.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dashboard from "../../pages/Dashboard/Dash";
import { Navigate, Routes, Route, NavLink, useNavigate } from 'react-router-dom';

import Usermgmt from "../../pages/User/Usermgmt";
import Ordermgmt from "../../pages/Ordermanagement/Ordermgmt";

import Productmgmt from "../../pages/Product/Productmgmt";

import Recived_orders from '../../pages/Recieve/Recieved';
import Couponmgmt from '../../pages/Coupon/Couponmgmt';
import WarrantyClaim from '../../pages/WarrantyClaim/WarrantyClaim';
import WarrantyReg from '../../pages/Warranty/WarrantyReg';

import ClaimFree from '../../pages/Claim-Free/claimfree';
import Analytics from '../../pages/Analysis/Analytics';

const Navbar = (props) => {
    const [order, setorder] = useState("")
    const [revenue, setrevenue] = useState("")
    const [user, setuser] = useState("")
    const [abond, setabond] = useState("0")
    const navigate = useNavigate()
    const getdashboarddata = async () => {
        try {
            await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetDashboard`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${window.localStorage.getItem('token')}`
                }
            }).then((res) => res.json()).then((response) => {
                if (response.status === 200) {
                    setorder(response.data.OrderCount)
                    setrevenue(response.data.Revenue)
                    setuser(response.data.UserCount)
                    setabond(0)
                } else {
                    if (response.message == "Unauthorized Access") {
                        window.localStorage.clear()
                        props.setisLoggedIn(false)
                        navigate('/')
                        toast.error(response.message, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        setorder(0)
                        setrevenue(0)
                        setuser(0)
                        setabond(0)
                    }

                }
            })
        } catch (error) {
            console.error('API Error:', error);
        }

    }
    useEffect(() => {
        getdashboarddata()
    }, [])

    return (
        <>
            <div id="content" className={props.active ? "top-navbarfull" : "top-navbar"}>

                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">

                        <div id="sidebarCollapse" className="btn nav-buton" onClick={() => {
                            props.handlesidebar()
                        }}>
                            <img src="assets/threedot.svg" alt="" width="30px" />
                            <a href="javascript:void(0)"></a>
                        </div>
                        <ul className="nav navbar-nav ml-auto">
                            <li>
                                <NavLink to="/Dashboard">Login as Admin</NavLink>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className={props.active?'fixedContent':'fixedContentActive'}>
                    <Routes>
                        {props.isLoggedIn ? <Route exact path="/Dashboard" element={<Dashboard />} /> : <Route exact path="/Dashboard" element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path="/Received_orders" element={<Recived_orders />} /> : <Route exact path="/Received_orders" element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path="/Users" element={<Usermgmt />} /> : <Route exact path="/Users" element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path="/order_management" element={<Ordermgmt />} /> : <Route exact path="/order_management" element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path="/product_management" element={<Productmgmt />} /> : <Route exact path="/product_management" element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path="/coupon_management" element={<Couponmgmt />} /> : <Route exact path="/coupon_management" element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path='/warranty_claim' element={<WarrantyClaim />} /> : <Route exact path='/warranty_claim' element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path='/warranty_registration' element={<WarrantyReg />} /> : <Route exact path='/warranty_registration' element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path='/claim-free' element={<ClaimFree />} /> : <Route exact path='/claim-free' element={<Navigate to="/" />} />}
                        {props.isLoggedIn ? <Route exact path="/Analytics" element={<Analytics />} /> : <Route exact path="/Analytics" element={<Navigate to="/" />} />}

                    </Routes>
                </div>
            </div>
        </>
    );
}
export default Navbar;
